export const isJSONArray = (_) => Boolean(_ && Array.isArray(_));
export const isJSONRecord = (_) => Boolean(_ && !Array.isArray(_) && typeof _ === 'object');
export const isJSONRef = (_) => Boolean(isJSONRecord(_) && typeof _.$ref === 'string');
